<template>
  <div>
    <!-- Section Header -->
    <div class="text-center mb-4">
      <h2 class="fw-bold text-primary" style="font-size: 1.75rem; letter-spacing: 0.5px;">
        🎓 Detailed Student View
      </h2>
      <p class="text-muted" style="font-size: 0.95rem;">
        Overview of student applications and their respective responses
      </p>
    </div>

    <b-col class="text-left">
      <b-button class="mb-2" @click="prepareExport()" variant="primary">Export to Excel</b-button>
   
      <b-button class="mb-2" @click="downloadAdmissionformFullDetails()" variant="danger">Download</b-button>
    </b-col>

    <div class="table-responsive rounded">
      <table class="table table-striped table-bordered" id="institutionUserDetails">
        <thead class="thead-dark text-left">
          <!-- First row: Section Names -->
          <tr>
            <th rowspan="2" style="padding: 10px; border: 1px solid #ddd;">
              Student Name
            </th>

            <th v-for="section in admissionFormDetails.admissionformsections" :key="'section-' + section.id"
              :colspan="section.admissionformquestions.length" class="text-center"
              style="padding: 10px; border: 1px solid #ddd;">
              {{ section.name }}
            </th>
          </tr>

          <!-- Second row: Questions inside each section -->
          <tr>
            <template v-for="section in admissionFormDetails.admissionformsections">
              <th v-for="question in section.admissionformquestions"
                :key="'question-' + section.id + '-' + question.id">
                {{ question.question_no }}) {{ question.name }}
              </th>
            </template>
          </tr>
        </thead>

        <tbody>
          <tr v-for="application in admissionFormDetails.applications" :key="'app-' + application.id">
            <!-- Student info -->
            <td style="padding: 8px 10px; border: 1px solid #ddd;">
              <div class="d-flex flex-column">
                <div class="d-flex align-items-center mb-1" style="gap: 6px;">
                  <input v-if="adminrole_admissiondesk && application.verified" type="checkbox"
                    v-model="selectedStudents"
                    :value="{ id: application.id, name: application.name, email: application.email }"
                    @change="toggleGoToClassButton" style="transform: scale(0.9);" />
                  <span class="fw-semibold text-dark" style="font-size: 0.85rem;">
                    {{ application.name }}
                  </span>
                </div>
              </div>
            </td>

            <!-- Student answers grouped by section/questions -->
            <template v-for="section in admissionFormDetails.admissionformsections">
              <td v-for="question in section.admissionformquestions"
                :key="'answer-' + application.id + '-' + section.id + '-' + question.id"
                style="padding: 10px; border: 1px solid #ddd;">
                {{ getAnswer(application.answers, question.id) }}

                <div v-if="getUploads(application.answers, question.id).length" class="mt-2">
                  <div class="uploaded-files">
                    <div v-for="(file, index) in getUploads(application.answers, question.id)"
                      :key="'file-' + application.id + '-' + question.id + '-' + index" class="file-item">
                      <a :href="userAttachments + file.file_path + file.file_name" target="_blank" class="file-link"
                        :title="file.file_name">
                        {{ formatFileName(file.file_name) }}
                      </a>
                    </div>
                  </div>
                </div>
              </td>
            </template>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import XLSX from "xlsx";
export default {
  data() {
    return {
      admissionFormDetails: { admissionformquestions: [], applications: [] },
      newQuestionsAnswerAttachments: {},
      uploadPercentage: {},
      userAttachments: null,
      selectedStudent: {},
    };
  },
  async created() {

    this.userAttachments = this.$store.getters.getAPIKey.userAttachments;
    await this.getAdmissionFormDetails();
  },
  methods: {
 
    async downloadAdmissionformFullDetails(viewReport) {
  this.loadReport = true;
  const url =
    this.$store.getters.getAPIKey.mainAPI +
    `/admissionforms/${this.$route.params.admissionform_id}/pdfexport`;

  await this.$axios
    .post(url, {}, { responseType: "blob" }) // FIX: moved responseType into config
    .then((response) => {
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = window.URL.createObjectURL(pdfBlob);
      let newTab = null;

      if (viewReport) {
        newTab = window.open(pdfUrl, "_blank");
      }

      if (!newTab) {
        if (viewReport) {
          this.$toast.error(
            "Failed to show pdf file, instead the file will be downloaded",
            { position: "top", duration: 3000 }
          );
        }
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.setAttribute(
          "download",
          `Admissionform.pdf`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    })
    .catch((error) => {
      let errorText = "Failed to Download, please check connectivity";
      if (error.response != undefined)
        errorText =
          error.response.status == 422
            ? "Custom report is not configured by admin"
            : "Failed to Download, please try again";
      this.$toast.error(errorText, { position: "top", duration: 3000 });
    });
  this.loadReport = false;
},

    async prepareExport() {
      this.edit = true;
      this.loadExams = true;
      await setTimeout(() => {
        this.exportToExcel("xlsx");
        this.edit = false;
        this.loadExams = false;
      }, 3000);
    },

    async exportToExcel(type, fn, dl) {
      var elt = document.getElementById("institutionUserDetails");
      var wb = await XLSX.utils.table_to_book(elt, { sheet: "Sheet JS" });
      this.loadExams = false;

      dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(wb, fn || "admisssionform." + (type || "xlsx"));
    },

    formatFileName(name) {
      // Optional: trim or shorten long names
      if (name.length > 30) {
        return name.slice(0, 25) + '...';
      }
      return name;
    },

    newFileInputMask(questionId) {
      let elementReference = `${"newFileInput" + questionId}`;
      this.$refs[elementReference][0].$refs.input.click();
    },
    async newFileInput(file, questionId) {
      this.$set(this.newQuestionsAnswerAttachments, questionId, []);
      this.newQuestionsAnswerAttachments[questionId].push(file.name);

      this.$set(this.uploadPercentage, questionId, {});
      this.$set(this.uploadPercentage[questionId], "value", 0);

      let index = this.newQuestionsAnswerAttachments[questionId].indexOf(
        file.name
      );

      await this.uploadAttachment(file[0], questionId);

      await this.newQuestionsAnswerAttachments[questionId].splice(index, 1);

      this.getUplodedAnswer(questionId);
      // // this.initiateAdmissionForm();
    },
    getAnswer(answers, questionId) {
      return answers?.find(ans => ans.question_id === questionId)?.answer || "";
    },

    getUploads(answers, questionId) {
      return answers?.find(ans => ans.question_id === questionId)?.files || [];
    },

    async getAdmissionFormDetails() {
      const admissionformId = this.$route.params.admissionform_id;
      const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionforms/${admissionformId}`;

      try {
        const { data } = await this.$axios.get(url);

        this.admissionFormDetails = {
          ...data,

          admissionformsections: data.admissionformsections.map(section => ({
            ...section,
            admissionformquestions: section.questions.map(q => {
              let choices = q.input_attributes[0]?.dropdown
                ? [{ value: null, text: "Select One" }]
                : [];

              if (q.answers.length !== 0) {
                choices.push(
                  ...q.answers.map(choice => ({
                    value: choice,
                    text: choice
                  }))
                );
              }

              return {
                id: q.id,
                name: q.name,
                question_no: q.question_no,
                input_attributes: q.input_attributes,
                choices: choices,
                allow_attachment: q.allow_attachment == 1,
              };
            }),
          })),

          applications: data.applications
            .filter(app => app.end_at !== null)
            .map(app => {
              const answers = app.answers?.map(ans => ({
                question_id: ans.question_id,
                answer: ans.answer,
                files: ans.files || [],
                verified_at: ans.verified_at,
                verified_by: ans.verifier
                  ? `${ans.verifier.first_name} ${ans.verifier.last_name}`
                  : null,
                modification_details: ans.modification_details,
              })) || [];

              // Check if all answers are verified
              const verified =
                answers.length > 0 && answers.every(ans => ans.verified_at !== null);

              return {
                id: app.id,
                name: app.name,
                email: app.email,
                end_at: app.end_at,
                usergroup: app.usergroup,
                answers: answers,
                verified: verified, // New flag to mark student's verification status
              };
            }),
        };
      } catch (e) {
        console.error("Error fetching admission form:", e);
      }

    },
  },
};
</script>
<style scoped>
.uploaded-files {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.file-item {
  font-size: 14px;
}

.file-link {
  color: #007bff;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s ease;
}

.file-link:hover {
  text-decoration: underline;
  color: #0056b3;
}

.file-link i {
  color: #555;
}
</style>